export default "__VITE_ASSET__C_bXU82I__"